export const localKeyList: string[] = [
  'VOICE_LEFT_STATE', // 左侧导航栏
  'VOICE_ROOMINFO_STATE', // 房间信息
  'VOICE_ROOMINFO_MSGITEM', // 房间信息
  'VOICE_ONLINEINFO_STATE', // 当前说话列表
  'VOICE_KICKINFO_STATE', // 被踢出房间列表
  'VOICE_MSGCONFIG_STATE', // 发言设置
  'VOICE_ROOMNUMTOTAL_STATE', // 总房间在线人数
  'VOICE_REPEATINFO_STATE', // 重复登录提示
  'VOICE_MICINFO_STATE', // 麦克风状态
  'VOICE_HEADTOP_STATE', // 顶部状态
  'VOICE_VALIDATEROOM_STATE', // 进入子房间密码
  'VOICE_VOLICELIVEINFO_STATE', // 直播模式信息
  'VOICE_VOLICKALAOKVOLUME_STATE', // 卡拉ok
  'VOICE_VOLICORTHER_STATE', // orther
  'VOICE_AGORAINFO_STATE' // agora
];

export const localKeyInfo = {
  leftInfo: localKeyList[0], // 左侧导航栏
  roomInfo: localKeyList[1], // 房间信息
  msgItem: localKeyList[2], // 房间信息
  onlineInfo: localKeyList[3], // 当前说话列表
  kickInfo: localKeyList[4], // 被踢出房间列表
  msgConfig: localKeyList[5], // 发言设置
  roomTotal: localKeyList[6], // 总房间在线人数
  repeatInfo: localKeyList[7], // 重复登录提示
  micInfo: localKeyList[8], // 麦克风状态
  headInfo: localKeyList[9], // 顶部状态
  validateInfo: localKeyList[10], // 进入子房间密码
  voiceLiveInfo: localKeyList[11], // 直播模式信息
  kalaokInfo: localKeyList[12], // 卡拉ok
  ortherInfo: localKeyList[13], // orther
  agoraInfo: localKeyList[14] // agora
};
